export type ClassType<C> = new(...args: any[]) => C;


/**
 * Base resource class contains properties and implements methods common for all object types.
 * Any GraphQL type serialized over the wire will be converted into the typescript class instance
 * derived from this class.
 */
export abstract class VcrEntity<T> {

  // wrapped data object
  // @ts-ignore
  public data: T;


  // added-to-favorites flag; this flag is automatically updated based on the favorites store state
  // public isFavorite: boolean = false;

  // Factory method for derived class instances; created instance will wrap the provided data object.
  // I updateCache is true, the existing cached instance will be updated, if found, and stored in cache

  public static createEntity<C extends VcrEntity<T>, T>(type: ClassType<C>, data: T): C {
    return new type(data);
  }

  // Constructor takes optional data object
  constructor(data?: T) {
    if (data) {
      this.setData(data);
    }
  }

  // Set internal data. This is the place to do verification and modification of data.
  public setData(data?: T): void {
    // patch the object if possible, to support partial objects updates
    data = data || ({} as T);
    if (this.data) {
      this.data = Object.assign(this.data, data);
    }
    else {
      this.data = data;
    }
  }

}

// public getInitInfo(): Observable<VcrInitData> {
//     return this.http.get(this.contextPath + this.baseUrl + '/init-info').pipe(
//       map((value: any) => {
//
//         const initData: VcrInitData = VcrEntity.createEntity(VcrInitData, value);
//         const user: User = VcrEntity.createEntity(User, value.currentUser);
//         initData.currentUser = user;
//         return initData;
//       }),
//       catchError(error => {
//           this.router.navigateByUrl('/login');
//           return of(null);
//         }
//       )
//     );
//   }

